import {Client as Styletron} from '@pinecast/styletron-engine-atomic';
import {Provider as StyletronProvider} from '@pinecast/styletron-react';
import * as React from 'react';

const engine = new Styletron();

export const Provider = ({children}: {children: React.ReactNode}) => (
  <StyletronProvider value={engine}>{children}</StyletronProvider>
);
